import { FlowConsumerContextEnergy as FlowContext } from '../../context';
import { energyTypeIncludes } from '../helpers';
import { EnergyType } from '../types';

export const shouldSkipWhenNoElectricity = (context: FlowContext): boolean => {
  const { energyType } = context;

  if (energyType) {
    return !energyTypeIncludes(energyType, EnergyType.Electricity);
  }

  return true;
};
